export default "__VITE_ASSET__35c5c977__"